import { Box } from "@mui/material";

const NotificationDot = ({ onClick, ...props }) => {
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      sx={{
        ...props.sx,
        position: "absolute",
        top: props.top,
        right: props.right,
        width: props.size,
        height: props.size,
        borderRadius: "50%",
        backgroundColor: props.color || "error.main",
        boxShadow: (theme) => `0 0 4px ${theme.palette.error.light}`,
        ...(props.pulse && {
          animation: "pulse 1.5s infinite",
          "@keyframes pulse": {
            "0%": { transform: "scale(0.95)" },
            "70%": { transform: "scale(1.1)" },
            "100%": { transform: "scale(0.95)" },
          },
        }),
      }}
    />
  );
};

export default NotificationDot;
